import React from 'react'
import PropTypes from 'prop-types'
import * as Icons from 'ui/icons'

export default function LanguageSwitcher ({ children, wrapperClasses, tablet = false }) {
  if (tablet) {
    return (
      <div className={'language-switcher ' + wrapperClasses}>
        <label className='flex flex-col items-center relative text-gray-500 hover:text-primary-900 text-xs'>
          <div className='w-5 h-5 flex-shrink-0 pointer-events-none'>
            <Icons.Globe />
          </div>
          {children}
        </label>
      </div>
    )
  }

  return (
    <div className={'language-switcher ' + wrapperClasses}>
      <label className='flex items-center relative text-gray-500 hover:text-primary-900'>
        <div className='w-5 h-5 flex-shrink-0 pointer-events-none absolute left-0'>
          <Icons.Globe />
        </div>
        {children}
      </label>
    </div>
  )
}

LanguageSwitcher.defaultProps = {
  wrapperClasses: 'px-8'
}

LanguageSwitcher.propTypes = {
  /**
     * Add classes to the wrapper element
     * Default class is px-8 (padding for the sidebar)
     */
  wrapperClasses: PropTypes.string,
  tablet: PropTypes.bool
}
